module.exports = __webpack_public_path__ + "img/agencies_blue.ee729b13.svg";